import type { GetTweetById200ReferencedTweetTweetAuthor } from './getTweetById200ReferencedTweetTweetAuthor';
import type { GetTweetById200ReferencedTweetTweetBasicInfo } from './getTweetById200ReferencedTweetTweetBasicInfo';
import type { GetTweetById200ReferencedTweetTweetEngagement } from './getTweetById200ReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type GetTweetById200ReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: GetTweetById200ReferencedTweetTweetAuthor;
  basicInfo?: GetTweetById200ReferencedTweetTweetBasicInfo;
  engagement?: GetTweetById200ReferencedTweetTweetEngagement;
};
